import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationSidePlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.1579 0V2.72727H18V4.54545H15.1579V7.27273H13.2632V4.54545H10.4211V2.72727H13.2632V0H15.1579ZM7.57895 10.9091C6.53684 10.9091 5.68421 10.0909 5.68421 9.09091C5.68421 8.09091 6.53684 7.27273 7.57895 7.27273C8.62105 7.27273 9.47368 8.09091 9.47368 9.09091C9.47368 10.0909 8.62105 10.9091 7.57895 10.9091ZM8.52632 1.87273V3.70909C8.21295 3.66147 7.89622 3.63715 7.57895 3.63636C4.40526 3.63636 1.89474 5.97273 1.89474 9.27273C1.89474 11.4 3.74211 14.2182 7.57895 17.5818C11.4158 14.2182 13.2632 11.4091 13.2632 9.27273V9.09091H15.1579V9.27273C15.1579 12.2909 12.6284 15.8636 7.57895 20C2.52947 15.8636 0 12.2909 0 9.27273C0 4.74545 3.6 1.81818 7.57895 1.81818C7.90105 1.81818 8.21368 1.83636 8.52632 1.87273Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLocationSidePlus);
export { ForwardRef as ReactComponent };
